import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import PluginService from 'services/PluginService';
import { PLUGINS } from 'queries/query-keys';
import { getChosenBusiness } from 'store/authentication/selectors';
import { getOriginalErrorStatusCode } from 'services/AxiosService';
import type { BusinessAppDetails } from './types';

export const useBusinessApp = (apiName: string, previewOwnerId?: string) => {
  const business = useSelector(getChosenBusiness);
  return useQuery<BusinessAppDetails>({
    queryKey: PLUGINS.GET_BUSINESS_APP(apiName, previewOwnerId),
    queryFn: () =>
      PluginService.getBusinessApp(business.id, apiName, previewOwnerId),
    staleTime: 0,
    // Details page redirects on a 404 preview
    throwOnError: (error) =>
      !(previewOwnerId && getOriginalErrorStatusCode(error) === 404),
  });
};
